export default "__VITE_ASSET__DfRUZ6RM__"